import { render, staticRenderFns } from "./allocate-credits.vue?vue&type=template&id=7cf8897e&scoped=true&"
import script from "./allocate-credits.vue?vue&type=script&lang=js&"
export * from "./allocate-credits.vue?vue&type=script&lang=js&"
import style0 from "./allocate-credits.vue?vue&type=style&index=0&id=7cf8897e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8897e",
  null
  
)

export default component.exports